import React from 'react'
import "../css/post-7626.css"
const faqs = [
    {
        id: 1,
        question: "What services does Burooj Properties offer?",
        answer:
            `Burooj Properties provides comprehensive real estate solutions, including property management, 
  facility management, buy and sell facilitation, and investment advisory services. We focus on 
  maximizing rental income and optimizing asset value for our clients.`,
    },
    {
        id: 2,
        question: "Why should I choose Burooj for my business needs?",
        answer:
            `Burooj has a proven track record of success, market leadership in Oman and the GCC, a 
  commitment to innovation, a focus on sustainability, and strong global partnerships. We create 
  opportunities that redefine industries`,
    },
    {
        id: 3,
        question: "What types of investments does Burooj Investments focus on?",
        answer:
            `Burooj Investments specializes in private equity, asset management, and 
  sustainable investing. We prioritize high-growth startups and ESG-driven opportunities to create 
  lasting wealth`,
    },
    {
        id: 4,
        question: "How does Burooj Trading support SMEs in Oman?",
        answer:
            `Burooj Trading assists SMEs by providing efficient product sourcing and distribution, 
  competitive pricing, and embedded supply chain finance options. We aim to facilitate market 
  entry and expansion for innovative products in Oman.`,
    },
    {
        id: 5,
        question: "How can I stay updated on Burooj’s latest projects and initiatives?",
        answer:
            `You can stay updated by subscribing to our newsletter on our website or following us on our 
  social media channels. We regularly share news about our projects, investment opportunities, and
  industry insights`,
    },
    {
        id: 6,
        question: "How does Burooj ensure sustainable practices in its operations?",
        answer:
            `Sustainability is embedded in our business strategies. We focus on environmentally friendly 
  practices in all our services, including sustainable investments and facility management solutions
  that prioritize energy efficiency`,
    },
];
const FaqPage = () => {
    const [activeId, setActiveId] = React.useState(null);

    const toggleFAQ = (id) => {
        setActiveId(activeId === id ? null : id);
    };
    return (
        <section
            className="elementor-section elementor-top-section elementor-element elementor-element-a1fe329 elementor-section-boxed elementor-section-height-default elementor-section-height-default cmsmasters-block-default"
            data-id="a1fe329"
            data-element_type="section"
        >
            <div className="elementor-container elementor-column-gap-no">
                <div
                    className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-4590363"
                    data-id={4590363}
                    data-element_type="column"
                >
                    <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                            className="elementor-element elementor-element-b5739d0 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                            data-id="b5739d0"
                            data-element_type="widget"
                            data-widget_type="heading.default"
                        >
                            <div className="elementor-widget-container">
                                <div className="elementor-heading-title elementor-size-default" style={{ textAlign: "center" }}>
                                    HELP CENTER
                                </div>{" "}
                            </div>
                        </div>
                        <div
                            className="elementor-element elementor-element-4756c81 cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-heading"
                            data-id="4756c81"
                            data-element_type="widget"
                            data-widget_type="heading.default"
                        >
                            <div className="elementor-widget-container">
                                <h2 className="elementor-heading-title elementor-size-default" style={{ textAlign: "center" }}>
                                    Frequently asked questions
                                </h2>{" "}
                            </div>
                        </div>
                        <div
                            className="elementor-element elementor-element-62f9aed cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-text-editor"
                            data-id="62f9aed"
                            data-element_type="widget"
                            data-widget_type="text-editor.default"
                        >
                            <div className="elementor-widget-container" style={{ textAlign: "center" }}>
                                <p>
                                    Got a question about how we’re organised,
                                    applying to work for us{" "}
                                    <br />
                                    <a href="/">
                                        View more Q&amp;A here
                                    </a>
                                </p>{" "}
                            </div>
                        </div>
                        <div
                            className="elementor-element elementor-element-bbeff21 cmsmasters-title-alignment-left cmsmasters-item-icon-position-left cmsmasters-trigger-icon-view-default cmsmasters-block-default cmsmasters-sticky-default elementor-widget elementor-widget-cmsmasters-toggles cmsmasters-widget-toggles"
                            data-id="bbeff21"
                            data-element_type="widget"
                            data-settings='{"toggles":[{"toggle_title":"I&apos;m having trouble accessing my account online. What should I do?","toggle_content":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.","_id":"fea7400","content_type":"toggle-content","saved_section":null,"saved_template":null,"item_icon":{"value":"","library":""},"toggle_custom_id":""},{"toggle_title":"What is the address I mail my credit card payment to?","toggle_content":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.","_id":"81ec36f","content_type":"toggle-content","saved_section":null,"saved_template":null,"item_icon":{"value":"","library":""},"toggle_custom_id":""},{"toggle_title":"How do I dispute a charge on my account?","toggle_content":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.","_id":"aba9bfa","content_type":"toggle-content","saved_section":null,"saved_template":null,"item_icon":{"value":"","library":""},"toggle_custom_id":""},{"toggle_title":"How do I contact the payment assistance team?","toggle_content":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.","_id":"7f9978a","content_type":"toggle-content","saved_section":null,"saved_template":null,"item_icon":{"value":"","library":""},"toggle_custom_id":""},{"toggle_title":"How do I activate a card?","toggle_content":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo.","_id":"7163114","content_type":"toggle-content","saved_section":null,"saved_template":null,"item_icon":{"value":"","library":""},"toggle_custom_id":""}],"type":"toggles"}'
                            data-widget_type="cmsmasters-toggles.default"
                        >
                            <div className="elementor-widget-container">
                                <div
                                    className="elementor-widget-cmsmasters-toggles__list"
                                    role="tablist"
                                >
                                    {faqs.map(({ id, question, answer }) => (
                                        <div key={id} className={`elementor-widget-cmsmasters-toggles__item ${activeId === id ? "active-toggle" : ""}`}>
                                            <h6
                                                className={`elementor-widget-cmsmasters-toggles__title ${activeId === id ? "active-toggle" : ""}`}
                                                onClick={() => toggleFAQ(id)}
                                            >
                                                <a
                                                    className="elementor-widget-cmsmasters-toggles__title-link cmsmasters_enable_trigger_icon"
                                                    type='button'
                                                >
                                                    {question}
                                                </a>
                                                <span className="elementor-widget-cmsmasters-toggles__title-text">
                                                    {activeId === id ? (<span className="elementor-widget-cmsmasters-toggles__trigger-opened">
                                                        <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-up" />
                                                    </span>) : (
                                                        <span className="elementor-widget-cmsmasters-toggles__trigger-closed">
                                                            <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-down" />
                                                        </span>)}
                                                </span>
                                            </h6>
                                            {activeId === id && <div
                                                id="elementor-widget-cmsmasters-toggles__content-1971"
                                                className="elementor-widget-cmsmasters-toggles__content elementor-clearfix"
                                                data-tab={1}
                                                role="tabpanel"
                                                aria-labelledby="elementor-tab-title-1971"
                                                style={{ display: activeId === id ? "block" : "none" }}
                                            >
                                                {answer}
                                            </div>}
                                        </div>
                                    ))}
                                    {/* <div className="elementor-widget-cmsmasters-toggles__item">
                     <h6
                       id="elementor-tab-title-1971"
                       className="elementor-widget-cmsmasters-toggles__title"
                       data-tab={1}
                       role="tab"
                       aria-controls="elementor-widget-cmsmasters-toggles__content-1971"
                       aria-expanded="false"
                     >
                       <a
                         className="elementor-widget-cmsmasters-toggles__title-link cmsmasters_enable_trigger_icon"
                         href="#"
                       >
                         <span className="elementor-widget-cmsmasters-toggles__title-text">
                           I'm having trouble accessing my account
                           online. What should I do?
                         </span>
                       </a>
                       <span
                         className="elementor-widget-cmsmasters-toggles__trigger"
                         aria-hidden="true"
                       >
                         <span className="elementor-widget-cmsmasters-toggles__trigger-closed">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-down" />
                         </span>
                         <span className="elementor-widget-cmsmasters-toggles__trigger-opened">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-up" />
                         </span>
                       </span>
                     </h6>
                     <div
                       id="elementor-widget-cmsmasters-toggles__content-1971"
                       className="elementor-widget-cmsmasters-toggles__content elementor-clearfix"
                       data-tab={1}
                       role="tabpanel"
                       aria-labelledby="elementor-tab-title-1971"
                     >
                       Lorem ipsum dolor sit amet, consectetur
                       adipiscing elit. Ut elit tellus, luctus nec
                       ullamcorper mattis, pulvinar dapibus leo.
                     </div>
                   </div>
                   <div className="elementor-widget-cmsmasters-toggles__item">
                     <h6
                       id="elementor-tab-title-1972"
                       className="elementor-widget-cmsmasters-toggles__title"
                       data-tab={2}
                       role="tab"
                       aria-controls="elementor-widget-cmsmasters-toggles__content-1972"
                       aria-expanded="false"
                     >
                       <a
                         className="elementor-widget-cmsmasters-toggles__title-link cmsmasters_enable_trigger_icon"
                         href="#"
                       >
                         <span className="elementor-widget-cmsmasters-toggles__title-text">
                           What is the address I mail my credit
                           card payment to?
                         </span>
                       </a>
                       <span
                         className="elementor-widget-cmsmasters-toggles__trigger"
                         aria-hidden="true"
                       >
                         <span className="elementor-widget-cmsmasters-toggles__trigger-closed">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-down" />
                         </span>
                         <span className="elementor-widget-cmsmasters-toggles__trigger-opened">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-up" />
                         </span>
                       </span>
                     </h6>
                     <div
                       id="elementor-widget-cmsmasters-toggles__content-1972"
                       className="elementor-widget-cmsmasters-toggles__content elementor-clearfix"
                       data-tab={2}
                       role="tabpanel"
                       aria-labelledby="elementor-tab-title-1972"
                     >
                       Lorem ipsum dolor sit amet, consectetur
                       adipiscing elit. Ut elit tellus, luctus nec
                       ullamcorper mattis, pulvinar dapibus leo.
                     </div>
                   </div>
                   <div className="elementor-widget-cmsmasters-toggles__item">
                     <h6
                       id="elementor-tab-title-1973"
                       className="elementor-widget-cmsmasters-toggles__title"
                       data-tab={3}
                       role="tab"
                       aria-controls="elementor-widget-cmsmasters-toggles__content-1973"
                       aria-expanded="false"
                     >
                       <a
                         className="elementor-widget-cmsmasters-toggles__title-link cmsmasters_enable_trigger_icon"
                         href="#"
                       >
                         <span className="elementor-widget-cmsmasters-toggles__title-text">
                           How do I dispute a charge on my account?
                         </span>
                       </a>
                       <span
                         className="elementor-widget-cmsmasters-toggles__trigger"
                         aria-hidden="true"
                       >
                         <span className="elementor-widget-cmsmasters-toggles__trigger-closed">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-down" />
                         </span>
                         <span className="elementor-widget-cmsmasters-toggles__trigger-opened">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-up" />
                         </span>
                       </span>
                     </h6>
                     <div
                       id="elementor-widget-cmsmasters-toggles__content-1973"
                       className="elementor-widget-cmsmasters-toggles__content elementor-clearfix"
                       data-tab={3}
                       role="tabpanel"
                       aria-labelledby="elementor-tab-title-1973"
                     >
                       Lorem ipsum dolor sit amet, consectetur
                       adipiscing elit. Ut elit tellus, luctus nec
                       ullamcorper mattis, pulvinar dapibus leo.
                     </div>
                   </div>
                   <div className="elementor-widget-cmsmasters-toggles__item">
                     <h6
                       id="elementor-tab-title-1974"
                       className="elementor-widget-cmsmasters-toggles__title"
                       data-tab={4}
                       role="tab"
                       aria-controls="elementor-widget-cmsmasters-toggles__content-1974"
                       aria-expanded="false"
                     >
                       <a
                         className="elementor-widget-cmsmasters-toggles__title-link cmsmasters_enable_trigger_icon"
                         href="#"
                       >
                         <span className="elementor-widget-cmsmasters-toggles__title-text">
                           How do I contact the payment assistance
                           team?
                         </span>
                       </a>
                       <span
                         className="elementor-widget-cmsmasters-toggles__trigger"
                         aria-hidden="true"
                       >
                         <span className="elementor-widget-cmsmasters-toggles__trigger-closed">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-down" />
                         </span>
                         <span className="elementor-widget-cmsmasters-toggles__trigger-opened">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-up" />
                         </span>
                       </span>
                     </h6>
                     <div
                       id="elementor-widget-cmsmasters-toggles__content-1974"
                       className="elementor-widget-cmsmasters-toggles__content elementor-clearfix"
                       data-tab={4}
                       role="tabpanel"
                       aria-labelledby="elementor-tab-title-1974"
                     >
                       Lorem ipsum dolor sit amet, consectetur
                       adipiscing elit. Ut elit tellus, luctus nec
                       ullamcorper mattis, pulvinar dapibus leo.
                     </div>
                   </div>
                   <div className="elementor-widget-cmsmasters-toggles__item">
                     <h6
                       id="elementor-tab-title-1975"
                       className="elementor-widget-cmsmasters-toggles__title"
                       data-tab={5}
                       role="tab"
                       aria-controls="elementor-widget-cmsmasters-toggles__content-1975"
                       aria-expanded="false"
                     >
                       <a
                         className="elementor-widget-cmsmasters-toggles__title-link cmsmasters_enable_trigger_icon"
                         href="#"
                       >
                         <span className="elementor-widget-cmsmasters-toggles__title-text">
                           How do I activate a card?
                         </span>
                       </a>
                       <span
                         className="elementor-widget-cmsmasters-toggles__trigger"
                         aria-hidden="true"
                       >
                         <span className="elementor-widget-cmsmasters-toggles__trigger-closed">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-down" />
                         </span>
                         <span className="elementor-widget-cmsmasters-toggles__trigger-opened">
                           <i className="cmsmsdemo-icon- cmsms-demo-icon-arrow-up" />
                         </span>
                       </span>
                     </h6>
                     <div
                       id="elementor-widget-cmsmasters-toggles__content-1975"
                       className="elementor-widget-cmsmasters-toggles__content elementor-clearfix"
                       data-tab={5}
                       role="tabpanel"
                       aria-labelledby="elementor-tab-title-1975"
                     >
                       Lorem ipsum dolor sit amet, consectetur
                       adipiscing elit. Ut elit tellus, luctus nec
                       ullamcorper mattis, pulvinar dapibus leo.
                     </div>
                   </div> */}
                                </div>{" "}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default FaqPage
